"use client";

import { useEffect } from "react";

export default function ScrollTop() {
  useEffect(() => {
    if (typeof window !== "undefined" && "scrollRestoration" in window.history) {
      // Prevent the browser from restoring the previous scroll on reload
      window.history.scrollRestoration = "manual";
    }
    // Ensure we start at the top after hydration
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  }, []);

  return null;
}